import { Component, OnInit, Inject } from "@angular/core";
import { DrawerRef } from "mis-design-system/drawer";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { FormControl, Validators } from "@angular/forms";
import { ApiService } from "../../../services/api.service";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { DropdownItem } from "mis-crystal-design-system/dropdown";
import { ToastService } from "mis-crystal-design-system/toast";
import { DRAWER_DATA_VAR } from "mis-design-system/drawer";
import { BookingDataService } from "../../../services/booking-data.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "mis-employee-web-exp-vehicle-create-form",
  templateUrl: "./vehicle-create-form.component.html",
  styleUrls: ["./vehicle-create-form.component.scss"]
})
export class VehicleCreateFormComponent implements OnInit {
  userInfo: any = {
    buid: "",
    empGuid: ""
  };
  constructor(
    private drawerRef: DrawerRef,
    private apiSvc: ApiService,
    private toasts: ToastService,
    private bookingSvc: BookingDataService,
    private _translateSvc: TranslateService,
    @Inject(DRAWER_DATA_VAR) userData
  ) {
    this.userInfo = userData;
  }
  configs: any;
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  showCar: boolean = false;
  showBike: boolean = false;
  isBikeActive: boolean = true;
  vehicleType: any[] = [];
  enableSaveBtn: boolean = false;
  selectedVehicle: "BIKE" | "CAR" = "BIKE";
  showVehicleNameInput: boolean = true;
  regNo = new FormControl("", Validators.required);
  vehicleName = new FormControl("", Validators.required);
  showLoader: boolean = false;
  vehicleBuildDetailsInfo: DropdownItem[] = [];
  selectedVehicleBuildDetails: DropdownItem = {
    label: "",
    value: ""
  };
  vehicleCreatePayload: NsEmpWebExpData.IVehicleCreateDetails = {
    name: "",
    type: "BIKE",
    build: "",
    number: ""
  };
  vehicleCreationDuringParkingFor: Array<string> = [];

  showRegNo: boolean = false;

  vehcileNamePlaceholder: string = "Kawasaki Ninja";

  ngOnInit(): void {
    this.showRegNo = this.bookingSvc?.formConfiguration?.userConfigs?.flattenedSettings?.showRegistrationNumberInputFieldForParking;
    this.vehicleCreationDuringParkingFor = this.bookingSvc?.formConfiguration?.userConfigs?.flattenedSettings?.vehicleCreationDuringParkingFor;
    if(this.vehicleCreationDuringParkingFor.length > 0 && this.vehicleCreationDuringParkingFor.includes('CAR') && !this.vehicleCreationDuringParkingFor.includes('BIKE')){
      this.selectVehicle('CAR');
    }
    else if(this.vehicleCreationDuringParkingFor.length > 0 && this.vehicleCreationDuringParkingFor.includes('BIKE') && !this.vehicleCreationDuringParkingFor.includes('CAR')){
      this.selectVehicle('BIKE');
    }
    this.vehicleBuildDetailsInfo = [];
  }

  fetchVehicleBuildDetails() {
    this.showLoader = true;
    this.apiSvc.getVehicleBuildDetails("PARKING", this.userInfo.buid, this.userInfo.empGuid).subscribe({
      next: (res: NsEmpWebExpData.IVehicleBuildDetails[]) => {
        if (!!res) {
          this.vehicleBuildDetailsInfo =
            res.length > 0
              ? res.map((item: NsEmpWebExpData.IVehicleBuildDetails) => ({
                  label: item.seatTypeName,
                  value: item.seatTypeId.toString()
                }))
              : [];
        } else {
          this.toasts.displayMsg(`${this._translateSvc.instant("Unable to fetch Vehicle Build Details")}`, 2000);
        }
        this.showLoader = false;
      },
      error: err => {
        this.showLoader = false;
        this.toasts.displayMsg(`${this._translateSvc.instant("Unable to fetch Vehicle Build Details")}`, 2000);
      }
    });
  }

  selectVehicleBuild(event) {
    this.selectedVehicleBuildDetails = event;
  }

  selectVehicle(type: "CAR" | "BIKE") {
    this.showVehicleNameInput = false;
    this.isBikeActive = type === "BIKE";
    this.vehcileNamePlaceholder = this.isBikeActive ? "Kawasaki Ninja" : "BMW X6";
    setTimeout(() => {
      this.showVehicleNameInput = true;
    }, 10);
    if (this.vehicleBuildDetailsInfo.length === 0) {
      !this.isBikeActive && this.fetchVehicleBuildDetails();
    }
    if (this.isBikeActive) {
      this.selectedVehicleBuildDetails = {
        label: "",
        value: ""
      };
      this.vehicleCreatePayload.build = "-1";
    }
    this.selectedVehicle = type;
    this.vehicleCreatePayload.type = this.selectedVehicle;
  }

  saveVehicleDetails() {
    this.vehicleCreatePayload = {
      name: this.vehicleName.value.trim(),
      type: this.selectedVehicle,
      build: !this.isBikeActive ? this.selectedVehicleBuildDetails.value : "-1",
      number: this.regNo.value.trim()
    };
    this.showLoader = true;
    this.apiSvc.createVehicle([this.vehicleCreatePayload], this.userInfo.buid, this.userInfo.empGuid).subscribe({
      next: res => {
        this.toasts.displayMsg(`${this._translateSvc.instant("Vehicle successfully added")}`, 2000);
        this.showLoader = false;
        this.drawerRef.close(true);
      },
      error: err => {
        this.toasts.displayMsg(`${this._translateSvc.instant("Failed to add vehicle")}`, 2000);
        this.showLoader = false;
      }
    });
  }

  closeDrawer() {
    this.drawerRef.close(false);
  }
}
